import MasterCrudPage from '../../components/MasterCrudPage';

export default function FwlMaster() {
  return (
    <MasterCrudPage
      config={{
        title: 'FWL',
        apiBase: '/payroll/masters/fwl',
        listKey: 'fwls',
        entityKey: 'fwl',
        fields: [
          { key: 'dailyRate', label: 'Daily Rate', type: 'number' },
          { key: 'maxPerMonth', label: 'Max per Month', type: 'number' },
        ],
      }}
    />
  );
}
